export default __webpack_public_path__ + "static/media/98-02_header_invoice.9fd9704f.png";